import {Button, Stack, Typography, useMediaQuery} from "@mui/material";
import likeICon from "../../images/svg/Like.svg"
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
// import backgroundStar from '../../images/backgroundStar.png'
import backgroundStar from '../../images/svg/backgroundStar.svg'
import {useHistory} from "react-router";
import {useTheme} from "@mui/material/styles";

export const SuccessConfirmation = () => {
    const history = useHistory()
    const theme = useTheme();
    const bp = useMediaQuery(theme.breakpoints.down('sm'))
    return (
        <Stack sx={{minHeight: "120vh", backgroundColor: "#ffffff"}}>
            <Stack justifyContent="center" alignItems="center"
                   sx={{
                       minHeight: bp ? "30vh" : "60vh",
                       marginBottom: 5,
                       backgroundImage: `url(${backgroundStar})`,
                       backgroundPosition: "center",
                       backgroundSize: "cover",
                       backgroundRepeat: "no-repeat"
                   }}>
                <img src={likeICon} alt="" style={{width: bp ? 150 : 291, height: bp ? 126 : 274}}/>
            </Stack>
            <Stack direction="column" alignItems="center" sx={{textAlign: "center"}}>
                <Typography fontFamily={"Josefin Sans"} fontSize={64} color={"#890608"}>Thank you!</Typography>
                <Stack direction={"row"} justifyContent="center" alignItems="center">
                    <CheckCircleRoundedIcon
                        style={{width: 50, height: 50, color: "#4ECB71"}}/>
                    <Typography fontFamily={"Josefin Sans"} marginLeft={2} fontSize={28} color={"#000"}
                                sx={{opacity: .7}}> Email
                        Verified
                        Successfully</Typography>
                </Stack>
                <Typography variant={"body1"} sx={{opacity: 0.4}}
                            marginBottom={2}
                            fontFamily={"Josefin Sans"}
                            color="text.secondary"
                >
                    Now, you can start creating ads or search for the rental house that suits you
                </Typography>
                <Button onClick={() => history.push('/')} variant="contained" size="medium" sx={{maxWidth: 250}}>Go to
                    the Homepage</Button>
            </Stack>
        </Stack>
    )
}